export enum RouteName {
  StyleView = "PM_StyleView",
  PersonRegistration = "PM_PersonRegistration",
  PrivacyPolicy = "PM_PrivacyPolicy",
  IdentificationUploader = "PM_IdentificationUploader",
  ExternalUploader = "PM_ExternalUploader",
  PersonContactInfo = "PM_PersonContactInfo",
  Rejected = "PM_Rejected",
  Correction = "PM_Correction",
  PasswordCreation = "PM_PasswordCreation",
  PaymentMethod = "PM_PaymentMethod",
  WaitValidation = "PM_WaitValidation",
  IdRejected = "PM_IdRejected",
  RegistrationExpired = "PM_RegistrationExpired",
  RegistrationComplete = "PM_RegistrationComplete",
  StepwiseContactInfo = "PM_StepwiseContactInfo",
}
